import React from 'react';
import PropTypes from 'prop-types';
import styles from '../detail.module.less';

const propTypes = {
  descHtml: PropTypes.string,
};
const defaultProps = {
  descHtml: '',
};

const DescHtml = (props) => {
  const { descHtml } = props;
  return (
    <div className={styles.desc_html_box}>
      <p className={styles.desc_title}>产品详情</p>
      <div className={styles.html} dangerouslySetInnerHTML={{ __html: descHtml }} />
    </div>
  );
};

DescHtml.propTypes = propTypes;
DescHtml.defaultProps = defaultProps;

export default DescHtml;
